module.exports = __webpack_public_path__ + "assets/img/Type E (74).f9e93fb2.jpg";